module.exports = __webpack_public_path__ + "img/20200515_162802.ab620d67.jpg";